import { render, staticRenderFns } from "./workersTable.vue?vue&type=template&id=7b6cc860&scoped=true"
import script from "./workersTable.vue?vue&type=script&lang=js"
export * from "./workersTable.vue?vue&type=script&lang=js"
import style0 from "./workersTable.vue?vue&type=style&index=0&id=7b6cc860&prod&scoped=true&lang=css"
import style1 from "./workersTable.vue?vue&type=style&index=1&id=7b6cc860&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6cc860",
  null
  
)

export default component.exports